export const ubsNavLinks = [
  { name: 'user.lower-nav-bar.sorting-rules', route: 'https://nowaste.com.ua/sort-station/', url: true },
  { name: 'user.lower-nav-bar.user-agreement', route: '/ubs/user-agreement', url: false },
  { name: 'user.lower-nav-bar.eco-shop', route: 'https://shop.nowaste.com.ua/', url: true },
  { name: 'Green City', route: '/greenCity', url: false }
];

export const socialLinks = [
  {
    name: 'Patreon',
    url: 'https://www.patreon.com/NowasteUkraine',
    icon: 'assets/admin-header/patreon-icon.svg'
  },
  {
    name: 'TikTok',
    url: 'https://www.tiktok.com/@nowasteukraine',
    icon: 'assets/admin-header/tik-tok-icon.svg'
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/NowasteUkraine/',
    icon: 'assets/admin-header/face-icon.svg'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/nowasteukraine/',
    icon: 'assets/admin-header/insta-icon.svg'
  },
  {
    name: 'Telegram',
    url: 'https://t.me/nowasteukraine',
    icon: 'assets/admin-header/telegram-icon.svg'
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/channel/UChFVBZ_HcaQYiF-GcMHiCNA',
    icon: 'assets/admin-header/you-tube-icon.svg'
  }
];
